import { render, staticRenderFns } from "./SquawkTile.vue?vue&type=template&id=90319512&scoped=true"
import script from "./SquawkTile.vue?vue&type=script&lang=js"
export * from "./SquawkTile.vue?vue&type=script&lang=js"
import style0 from "./SquawkTile.vue?vue&type=style&index=0&id=90319512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90319512",
  null
  
)

export default component.exports